module.exports = __webpack_public_path__ + "static/media/logo-fronteiras-edu.6ca183de.png";